// extracted by mini-css-extract-plugin
module.exports = {"WelcomeFocus":"Welcome_WelcomeFocus__3w4l1","WelcomeImage":"Welcome_WelcomeImage__3Dv8C","Padding":"Welcome_Padding__2Z1Tr"};